import apiFetch from '../apiFetch'

export default function (idPool) {
  return apiFetch({endPoint: `Analisis/obtenerTokenMagavisionPool?idPool=${idPool}`, method: 'GET', body: null})
}
